

// fileValidator.js
import { toast } from "react-toastify";
// import "pdfjs-dist/build/pdf.worker.entry";

const EXCEL_BINARY_MAGIC = "d0cf11e0a1b11ae1";
/** OpenXML (ZIP-tabanlı) formatı için magic number (4 bayt hex) */
const ZIP_MAGIC = "504b0304";

const getFileHeader = async (file, slice = 4) => {
    const buf = await file.arrayBuffer();
    const bytes = new Uint8Array(buf.slice(0, slice));
    return Array.from(bytes).map((b) => b.toString(16).padStart(2, "0")).join("");
  };

async function isValidExcelMagic(file) {
    const header = await getFileHeader(file, 8);
    // BIFF
    if (file.name.match(/\.(xls|xlt|xlm|xlsb)$/i)) {
      return header.startsWith(EXCEL_BINARY_MAGIC);
    }
    // OpenXML (zip) — aynen tüm zip dosyalarına ait imza
    if (file.name.match(/\.(xlsx|xlsm|xltx|xltm)$/i)) {
      return header.startsWith(ZIP_MAGIC);
    }
    return false;
  }

export async function validateExcelFile({ file, allowedTypes = ["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel.sheet.macroEnabled.12"], maxSize = 5 * 1024 * 1024}) {
  // Tür kontrolü
  
  if (!allowedTypes.includes(file.type)) {
    toast.error("Geçersiz dosya türü.");
    return null;
  }

  // Boyut kontrolü
  if (file.size > maxSize) {
    toast.error("5MB’dan büyük dosya seçilemez.");
    return null;
  }

  // Magic-number kontrolü
  if (!(await isValidExcelMagic(file))) {
    return null;
  }

  // Tüm kontroller geçti
  return file;
}